const $ = window.jQuery;

export default class Home {
  constructor() {

    $(document).on('click', 'body.home section.services .bloc ul.list li.single', (e) => {
      this.selectProduct(e);
    });

    $(document).on('click', 'body.home section.services .bloc.list-illus .inside', (e) => {
      this.showProduct(e);
    });

    $(document).on('mouseenter', '.services .bloc.list-illus .inside, .services .bloc .list .single', (e) => {
      let getClass = $(e.currentTarget)[0].classList[1];
      
      if(!$('.services .bloc.list-illus .inside.' + getClass).hasClass('visible')){
        $('.services .bloc.list-illus .inside.' + getClass).addClass('active');
        $('.services .bloc .list .single.' + getClass).addClass('active');
      }
    });

    $(document).on('mouseleave', '.services .bloc.list-illus .inside, .services .bloc .list .single', (e) => {
      $('.services .bloc.list-illus .inside, .services .bloc .list .single').removeClass('active');
    });

    this.splitTxt($('.home .presentation .middle-part .title-part h1'));
    this.splitTxt($('.home .presentation .middle-part .title-part .tagline'));

    this.loadSprites();
  }

  selectProduct(elt) {
    $('body.home section.services .bloc.list-illus .col-6 .inside').removeClass('visible');
    $('body.home section.services .bloc ul.list li.single').removeClass('active');

    $(elt.currentTarget).addClass('active');
    let idx = $(elt.currentTarget).index();
    $('body.home section.services .bloc.list-illus .col-6').eq(idx).find('.inside').addClass('visible');
  }

  showProduct(elt) {
    $('body.home section.services .bloc.list-illus .col-6 .inside').removeClass('visible');
    $('body.home section.services .bloc ul.list li.single').removeClass('active');

    let getClass = $(elt.currentTarget)[0].classList[1];
    $('.services .bloc .list .single.' + getClass).addClass('active');
    $(elt.currentTarget).addClass('visible');
  }

  splitTxt(elt) {
    elt.css('opacity', '1');
    let getText = elt.text();
    elt.empty();

    let word = getText.split('');
    for(let letter in word){
      elt.append('<span>' + word[letter] + '</span>');
    }
  }
  loadSprites() {
    $('.home .services .list-illus .inside .figure').each( (index, element) => {
      let getUrl = $(element).attr('data-sprite');
      $(element).css('background-image', 'url(' + getUrl + ')');
    });
  }
}
